export const LOAN_STATUSES = {
    OVERDUE: 'overdue',
    TOPUP: 'topup',
    PENDING: 'pending',
    ONGOING: 'ongoing',
    DUE_TODAY: 'duetoday',
    ENDED: 'ended'
};
